import { Collection } from 'modules/core/lib/mobx-rest'

import Presence from 'modules/attendance/store/models/Presence'

class Presences extends Collection<Presence> {
  get cacheKey(): string {
    return 'presences'
  }

  model() {
    return Presence
  }

  get primaryKey(): string {
    return 'employee_id'
  }
}

const singleton: Presences = new Presences()

export default singleton
